import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { injectIntl } from 'react-intl'
import _ from 'lodash'

import config from '../../../../../../../../../config'

import { LOCALE_PREFIX, BLOCK_TYPE } from './constants'

import Tabs from '../../../../../../../../../components/Tabs'
import DistributionTab from './components/DistributionTab'
import OwnershipTab from './components/OwnershipTab'
import Summary from './components/Summary'

import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'
import hocConnect from './hocConnect'

@hocBlock(config.modules.report.key)
@hocConnect
@injectIntl
export default class Estates extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        data: PropTypes.object,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object.isRequired,
        level: PropTypes.string.isRequired,
        saveCustomData: PropTypes.func.isRequired,
        transformedData: PropTypes.object,
        type: PropTypes.oneOf([BLOCK_TYPE.BASIC, BLOCK_TYPE.EXTENDED]).isRequired,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.id !== nextProps.id) return true
        if (this.props.type !== nextProps.type) return true
        if (!_.isEqual(this.props.customData, nextProps.customData)) return true
        if (!_.isEqual(this.props.data, nextProps.data)) return true
        if (!_.isEqual(this.props.transformedData, nextProps.transformedData)) return true

        return false
    }

    render() {
        const { block, id, data, transformedData, customData, type, intl, saveCustomData, level } = this.props

        if (!data || !transformedData) return null

        // show only summary if entity hasn't estates (total === 0)
        if (_.get(data, 'summary.total', 0) === 0) return <Summary id={id} block={block} />

        const isPaidVersion = type === BLOCK_TYPE.EXTENDED

        const tabs = [
            {
                tabId: 'distribution',
                title: intl.formatMessage({ id: `${LOCALE_PREFIX}.tab.distribution` }),
                content: (
                    <DistributionTab
                        id={id}
                        block={block}
                        isPaidVersion={isPaidVersion}
                        customData={customData}
                        saveCustomData={saveCustomData}
                        transformedData={transformedData}
                    />
                ),
            },
        ]

        if (isPaidVersion) {
            tabs.push({
                tabId: 'ownership',
                title: intl.formatMessage({ id: `${LOCALE_PREFIX}.tab.ownership` }),
                content: <OwnershipTab id={id} block={block} locked={!isPaidVersion} saveCustomData={saveCustomData} />,
                locked: !isPaidVersion,
            })
        }

        return (
            <div className={cx('block-estates')}>
                <Tabs level={level} id={`${config.modules.report.key}_${id}_${block}_tabs`} tabs={tabs} inline />
            </div>
        )
    }
}
